import ActionIconGroup from "../../../../ActionIconGroup";
import { useChatListActionsBar } from "../../../../hooks/useChatListActionsBar";
import useCustomChatListAction from "../../../../hooks/useCustomChatListAction";
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var DefaultActionsBar = /*#__PURE__*/memo(function (_ref) {
  var text = _ref.text,
    onActionClick = _ref.onActionClick,
    actionsProps = _ref.actionsProps;
  var _useChatListActionsBa = useChatListActionsBar(text),
    del = _useChatListActionsBa.del;
  var _useCustomChatListAct = useCustomChatListAction({
      dropdownMenu: [del],
      items: [],
      actionsProps: actionsProps
    }),
    dropdownMenu = _useCustomChatListAct.dropdownMenu,
    items = _useCustomChatListAct.items;
  return /*#__PURE__*/_jsx(ActionIconGroup, {
    dropdownMenu: dropdownMenu,
    items: items,
    onActionClick: onActionClick,
    type: "ghost"
  });
});